module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [(_vm.loading) ? _c('spinner') : [_c('side-nav-bar', {
    attrs: {
      "filesOpen": _vm.filesOpen,
      "fileOpen": _vm.fileOpen,
      "fileId": _vm.appraisalfile.id,
      "fileNumber": _vm.appraisalfile.number,
      "reportOpen": _vm.reportOpen,
      "reportNumber": _vm.appraisalreport.number,
      "versionNumber": _vm.appraisalreport.version,
      "realEstates": _vm.appraisalreport_realestates,
      "realEstateId": _vm.realestate.id,
      "reportId": _vm.appraisalreport.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-container"
  }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Edit_Appraisal'))), (_vm.appraisal.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "datedata"
  }, [_c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisal.date_created)))]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisal.date_modified)))])]), _vm._v(" "), _c('div', {
    staticClass: "tab_container"
  }, [_c('span', [_vm._v("hola!")])])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d6c8bf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/appraisals/AppraisalContainer.vue
// module id = 2169
// module chunks = 0